import "../landing.scss";

import { useTranslation } from "react-i18next";

export const useLandingLP = () => {
  const { t } = useTranslation();

  return { t };
};
